import { toDateTime } from "Helpers/Format";

const formatCurrency = (value) =>
  value || value === 0
    ? Number(value).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      })
    : "";

const formatDate = (value) => (value ? toDateTime(value) : "");

export const downloadColumns = [
  { Header: "ID", accessor: "id" },
  { Header: "Nome", accessor: "name" },
  { Header: "Patrocinador", accessor: "sponsor_name" },
  { Header: "Início", accessor: (row) => formatDate(row.start_at) },
  { Header: "Fim", accessor: (row) => formatDate(row.finish_at) },
  {
    Header: "Valor mínimo",
    accessor: (row) => formatCurrency(row.min_contribution_value),
  },
  { Header: "Projetos", accessor: "projects_count" },
  { Header: "Status da Seletiva", accessor: "status_name" },
  {
    Header: "Situação",
    accessor: (row) => (row.inactivated_at ? "Inativo" : "Ativo"),
  },
  { Header: "Data de Criação", accessor: (row) => formatDate(row.created_at) },
];

export const columns = [
  { Header: "ID", accessor: "id" },
  { Header: "Nome", accessor: "name" },
  { Header: "Patrocinador", accessor: "sponsor_name" },
  { Header: "Início", accessor: (row) => formatDate(row.start_at) },
  { Header: "Fim", accessor: (row) => formatDate(row.finish_at) },
  {
    Header: "Valor mínimo",
    accessor: (row) => formatCurrency(row.min_contribution_value),
  },
  { Header: "Projetos", accessor: "projects_count" },
  // "Status da Seletiva" = publicação (Em montagem/Enviado/Finalizada).
  // "Situação" = ativo/inativo (soft delete) — eram duas coisas com o mesmo nome.
  { Header: "Status da Seletiva", accessor: "status_name" },
  {
    Header: "Situação",
    accessor: (row) => (row.inactivated_at ? "Inativo" : "Ativo"),
  },
];
